export default __webpack_public_path__ + "static/media/phil.de6fd1f1.jpg";